import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReparatieAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M6.92 23.88c1.71-1.71 4.13-2.28 6.31-1.71l8.94-8.94c-.58-2.17 0-4.59 1.71-6.31a6.54 6.54 0 0 1 6.31-1.71l-4.01 4.01 4.6 4.6 4.01-4.01c.58 2.17 0 4.59-1.71 6.31a6.54 6.54 0 0 1-6.31 1.71l-8.94 8.94c.58 2.17 0 4.59-1.71 6.31a6.54 6.54 0 0 1-6.31 1.71l4.01-4.01-4.6-4.6-4.01 4.01c-.58-2.17 0-4.59 1.71-6.31"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m23.65 17.644-9.002 9.001.707.707 9.001-9.001z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReparatieAanvragen);

export default ForwardRef;
